export const soDigitos = (v: string | null | undefined) => (v ?? '').replace(/\D/g, '');

/** Máscara só de exibição (`00000-000`); a API recebe dígitos. */
export function mascararCep(v: string | null | undefined) {
  const d = soDigitos(v).slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}

type EnderecoFormatavel = {
  endereco: string | null;
  numero: string | null;
  complemento: string | null;
  bairro: string | null;
  cidade: string | null;
  uf: string | null;
  cep: string | null;
};

/** `{{endereco}}, {{numero}}[ - {{complemento}}] – {{bairro}} – {{cidade}}/{{uf}} – CEP 00000-000` */
export function formatarEndereco(e: EnderecoFormatavel) {
  const comp = e.complemento ? ` - ${e.complemento}` : '';
  return `${e.endereco ?? ''}, ${e.numero ?? ''}${comp} – ${e.bairro ?? ''} – ${e.cidade ?? ''}/${e.uf ?? ''} – CEP ${mascararCep(e.cep)}`;
}
